import React, { Component, PropTypes } from 'react'

import { internetConnectionOptions, sendPatchRequest } from '../utils'

import { Select, TextInput } from '../ui'

export default class InternetConnectionForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
        updateValueAndSendPatchRequest: PropTypes.func.isRequired,
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-4">
                        <Select
                            error={ errors.internet_connection }
                            label="What type of connection do you have?"
                            name="internet_connection"
                            options={ internetConnectionOptions() }
                            placeholder="Select connection type"
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.internet_connection }
                        />
                        <TextInput
                            error={ errors.internet_service_provider }
                            handleBlur={ sendPatchRequest.bind(this, 'internet_service_provider') }
                            label="Who is your internet service provider?"
                            name="internet_service_provider"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.internet_service_provider }
                        />
                    </div>
                    <div className="grid__span-6">
                        <div className="grid grid--break-mobile">
                            <div className="grid__span-6">
                                <TextInput
                                    error={ errors.internet_upload_speed }
                                    handleBlur={ sendPatchRequest.bind(this, 'internet_upload_speed') }
                                    label="What is your upload speed?"
                                    name="internet_upload_speed"
                                    placeholder="100"
                                    subHelp="Please enter value in Mbps"
                                    updateValue={ this.props.updateValue }
                                    value={ this.props.data.internet_upload_speed }
                                />
                            </div>
                            <div className="grid__span-6">
                                <TextInput
                                    error={ errors.internet_download_speed }
                                    handleBlur={ sendPatchRequest.bind(this, 'internet_download_speed') }
                                    label="What is your download speed?"
                                    name="internet_download_speed"
                                    placeholder="100"
                                    subHelp="Please enter value in Mbps"
                                    updateValue={ this.props.updateValue }
                                    value={ this.props.data.internet_download_speed }
                                />
                            </div>
                        </div>
                        <p>
                            Not sure about your internet connection?
                            <br />
                            <a href="https://sourceforge.net/speedtest/" target="_blank">
                                Check your speed and details here.
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./app/components/personal/internet_connection_form.js